import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BannerModel } from '../models/banner.model';

@Injectable({
  providedIn: 'root'
})
export class BannerRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient
  ) { }

  public getAll(): Observable<Array<BannerModel>> {
    return this.httpClient.get<Array<BannerModel>>(`${this.apiUrl}/banner/active`);
  }

}
